import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { filter } from 'rxjs';
import { BrandLogoComponent } from '../brand-logo/brand-logo.component';
import { ButtonDirective } from '../button/button.directive';
import { IconComponent } from '../icon/icon.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-main-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, BrandLogoComponent, ButtonDirective, IconComponent, ModalComponent],
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainHeaderComponent {
  // Private variables

  @ViewChild('mobileMenu') private mobileMenu?: ModalComponent;

  // Public properties

  @Input() public signedIn = false;

  // Constructors

  constructor(router: Router) {
    router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed()).subscribe(() => this.closeMenu());
  }

  // Public methods

  public openMenu(): void {
    this.mobileMenu?.open();
  }

  public closeMenu(): void {
    this.mobileMenu?.close();
  }

  // Private methods
}
